module.exports = __webpack_public_path__ + "static/media/croningroup.5a4b0751.png";